import $ from 'jquery';

import { InfiniteScrollBase } from './base';

import { log } from '../utils/logger';
import check from '../utils/check-data-types';

const {
	infiniteScrollAPIURL,
	infiniteScrollNonce,
} = window.infiniteScrollParams;

/**
 * This class controls the request component of the infinite scroll throughout the site.
 */
export class InfiniteScrollRequest extends InfiniteScrollBase {
	/**
	 * Initialize the app.
	 *
	 * @param {string} mainContentCtnId
	 * @param {string} spinnerCtnId
	 * @param {string} noMoreCtnId
	 */
	constructor( mainContentCtnId, spinnerCtnId, noMoreCtnId ) {
		super( mainContentCtnId, spinnerCtnId, noMoreCtnId );
	}

	/**
	 * Get more articles and update the parameters of this class.
	 */
	getArticles() {
		this.requestArticles().then( ( response ) => {
			const { success, data } = response;

			if ( success ) {
				// Reset the failed requests count.
				this.consecutiveFailedRequests = 0;

				// Store the html of each section ready to be loaded to the dom.
				if ( ! check.isUndefined( data[ this.pageType ] ) ) {
					// Update the max number of pages.
					if ( ! check.isUndefined( data.max_num_pages ) ) {
						this.maxNumPages = parseInt( data.max_num_pages );
						if ( 0 === this.maxNumPages ) {
							this.noMorePages = true;
						}
					}

					// Grab the content for the next section.
					const responseContent = data[ this.pageType ];

					// Load each onto the sections array storage, for single page type there will be more than 1.
					for ( const [ key, section ] of Object.entries( responseContent ) ) {
						const { html, post_id } = section;
						this.loadMoreSectionQueue = html;
					}

				}

				this.paged++;
				this.hidePagination();
			} else {
				this.consecutiveFailedRequests++;
			}

			this.fetchingMore( false );
		} );
	}

	/**
	 * Query args used.
	 *
	 * paged = paged
	 * post__in = include
	 * post__not_in = exclude
	 * cat = category
	 * taxonomy = taxonomy
	 * term = term
	 * tag = tag
	 * author = author
	 * s = search
	 * offset = offset
	 */
	async requestArticles() {
		this.fetchingMore( true );

		const data = {
			is_infinite_scroll: 1, // Used by the site to determine if the loading section is a infinite scroll section.
			_wpnonce: infiniteScrollNonce,
			page_type: this.pageType,
			paged: ( this.paged + 1 ), // Don't increment until data has been successfully retrieved.
		};

		// Add other query args.
		if ( this.postType ) {
			data.post_type = this.postType;
		}

		if ( this.postsPerPage ) {
			data.posts_per_page = this.postsPerPage;
		}

		if ( this.category.length ) {
			data.category = this.category;
		}

		if ( this.taxonomy ) {
			data.taxonomy = this.taxonomy;
			if ( this.term ) {
				data.term = this.term;
			}
		}

		if ( this.tagID ) {
			data.tag_id = this.tagID;
		}

		if ( this.author ) {
			data.author = this.author;
		}

		if ( this.include ) {
			data.include = this.include;
		}

		if ( this.exclude.length ) {
			data.exclude = this.exclude;
		}

		if ( this.search ) {
			data.search = this.search;
		}

		if ( this.offset ) {
			data.offset = this.offset;
		}

		log( {
			type: 'info',
			message: 'Requesting Articles.',
			details: data,
		} );

		return await $.get( infiniteScrollAPIURL, data, ( response ) => {
			if ( check.isUndefined( response ) ) {
				response = {};
				response.success = false;
				response.message = 'Internal error with endpoint, incorrect response.';
			}

			if ( ! check.isUndefined( response.message ) ) {
				const type = response.success ? 'success' : 'warning';
				log( { type, message: response.message } );
			}

			return response;
		} ).fail( ( xhr, status, error ) => {
			log( {
				type: 'error',
				message: '',
				details: {
					xhr,
					status,
					error,
				},
			} );
			this.fetchingMore( false );
			this.consecutiveFailedRequests++;
		} );

	}

	/**
	 * helper method to identify that more is being fetched and update animations as well.
	 *
	 * @param {boolean} value
	 */
	fetchingMore( value ) {
		this.fetching = value;
		this.spinnerCtn.toggleClass( 'show', value );
	}

	/**
	 * Helper method to identify that no more can be fetched.
	 *
	 * @param {boolean} value
	 */
	noMore( value ) {
		this.noMoreCtn.toggleClass( 'show', value );
		this.end = true; // End of the JS app.
	}
}
